/** Volver atrás al listado: reutilizar componente en caché (RouteReuseStrategy). */
export function withListBackCacheState(): { reuseListCache: true } {
  return { reuseListCache: true };
}

/** Tras mutación: forzar recarga del listado (descartar caché). */
export function withListRefreshState(
  extra: Record<string, unknown> = {},
): Record<string, unknown> & { refreshList: true } {
  return { ...extra, refreshList: true as const };
}

export function isListBackCacheNavigationState(
  state: unknown,
): state is { reuseListCache: true } {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as { reuseListCache?: unknown }).reuseListCache === true
  );
}

export function isListRefreshNavigationState(
  state: unknown,
): state is { refreshList: true } {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as { refreshList?: unknown }).refreshList === true
  );
}
